import React, { useEffect, useState } from "react";
import { MessageCircle, UserX } from "lucide-react";
import { toast } from "sonner";
import { adminLeads, apiError } from "../../lib/adminApi";
import { Panel, fmtDate, fmtAgo, Empty } from "./ui";

export default function AdminLeads() {
  const [d, setD] = useState(null);
  useEffect(() => { adminLeads().then(setD).catch((e) => toast.error(apiError(e))); }, []);
  if (!d) return <div className="text-slate-500 text-[13px]">Carregando leads…</div>;

  return (
    <div className="space-y-6" data-testid="admin-leads">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Leads</h1>
        <p className="text-[13px] text-slate-400 mt-1">Quem demonstrou interesse mas ainda não virou cliente ativo.</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <Panel title={`WhatsApp sem conta (${d.whatsapp.length})`} testid="leads-whatsapp">
          {d.whatsapp.length ? (
            <ul className="divide-y divide-white/[0.05]">
              {d.whatsapp.map((p) => (
                <li key={p.phone} className="py-3 flex items-start justify-between gap-3" data-testid={`lead-${p.phone}`}>
                  <div>
                    <div className="flex items-center gap-2 text-[13.5px] font-medium"><MessageCircle size={14} className="text-[#25D366]" /> +{p.phone}</div>
                    {p.last_text && <div className="mt-0.5 text-[12px] text-slate-400 truncate max-w-[320px]">“{p.last_text}”</div>}
                  </div>
                  <div className="text-right text-[11.5px] text-slate-500 shrink-0">
                    <div>{p.messages} msg{p.messages === 1 ? "" : "s"}</div>
                    <div>{fmtAgo(p.last_message_at || p.first_contact)}</div>
                  </div>
                </li>
              ))}
            </ul>
          ) : <Empty text="Nenhum número aguardando conta" />}
        </Panel>
        <Panel title={`Free sem orçamento (${d.free_without_quote.length})`} testid="leads-free">
          {d.free_without_quote.length ? (
            <ul className="divide-y divide-white/[0.05]">
              {d.free_without_quote.map((u) => (
                <li key={u.user_id} className="py-3 flex items-center justify-between gap-3">
                  <div>
                    <div className="flex items-center gap-2 text-[13.5px] font-medium"><UserX size={14} className="text-amber-300" /> {u.name || u.email}</div>
                    <div className="text-[12px] text-slate-500">{u.email}</div>
                  </div>
                  <div className="text-right text-[11.5px] text-slate-500 shrink-0">
                    <div>cadastro {fmtDate(u.created_at)}</div>
                    <div>acesso {fmtAgo(u.last_seen_at)}</div>
                  </div>
                </li>
              ))}
            </ul>
          ) : <Empty text="Todo usuário Free já gerou orçamento" />}
        </Panel>
      </div>
    </div>
  );
}
